import type { ClusterPeriod } from '@atlassian/eoc-schedule-common';

import type { GetUserTimelineResponse } from '../../../common/types';
import { fromMergedPeriodResponseToClusterPeriod } from '../my-shifts/utils';

export const transformUserTimelineResponse = ({
	startTimeUtcMillis,
	endTimeUtcMillis,
	startOffsetMillis,
	endOffsetMillis,
	utcTimeOffsetMillis,
	currentTime,
	periods,
	...data
}: GetUserTimelineResponse): {
	data: {
		id: string;
		periods: ClusterPeriod[];
		timeZone: string;
		totalScheduleCount: number;
		totalTeamCount: number;
	};
	endEpoch: number;
	endOffset: number;
	nowEpoch: number;
	nowOffset: number;
	startEpoch: number;
	startOffset: number;
} => {
	return {
		startEpoch: startTimeUtcMillis,
		endEpoch: endTimeUtcMillis,
		nowEpoch: currentTime,
		startOffset: startOffsetMillis,
		endOffset: endOffsetMillis,
		nowOffset: utcTimeOffsetMillis,
		data: {
			...data,
			periods: periods.map(fromMergedPeriodResponseToClusterPeriod),
		},
	};
};
